var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { getPlatformApplications } from './api';
export function usePlatformApplications(messengerId) {
    const [platformApplications, setPlatformApplications] = useState([]);
    const [asyncStatus, setAsyncStatus] = useState('succeeded');
    const getPlatformApplicationsRequest = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!messengerId) {
            return;
        }
        setAsyncStatus('loading');
        try {
            const { data } = yield getPlatformApplications(messengerId);
            setPlatformApplications(data.platformApplications);
            setAsyncStatus('succeeded');
        }
        catch (_a) {
            setAsyncStatus('failed');
        }
    }), [messengerId]);
    useEffect(() => {
        getPlatformApplicationsRequest();
    }, [getPlatformApplicationsRequest]);
    return {
        items: platformApplications,
        asyncStatus,
        refreshItems: getPlatformApplicationsRequest,
    };
}
